var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustwallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 11.5562L35.5547 0V80C10.1581 69.3323 0 48.8881 0 37.3343V11.5562Z",
    fill: "#0500FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M71.1133 11.5562L35.5586 0V80C60.9552 69.3323 71.1133 48.8881 71.1133 37.3343V11.5562Z",
    fill: "url(#paint0_linear_72_3336)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_3336",
    x1: 61.669,
    y1: -5.60212,
    x2: 34.8103,
    y2: 78.9071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0500FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustwallet);
export default __webpack_public_path__ + "static/media/trustwallet.2d08a562a82e79ec265cbec8611e2b15.svg";
export { ForwardRef as ReactComponent };